import { render, staticRenderFns } from "./ghost.vue?vue&type=template&id=e286eca4&scoped=true"
import script from "./ghost.vue?vue&type=script&lang=js"
export * from "./ghost.vue?vue&type=script&lang=js"
import style0 from "./ghost.vue?vue&type=style&index=0&id=e286eca4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e286eca4",
  null
  
)

export default component.exports